import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OnACallMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "routing-ui.reassignment.capacityStatus.onACall"
});
OnACallMessage.displayName = 'OnACallMessage';
export const FullCapacityMessage = ({
  messageType
}) => {
  const getMessageContent = () => {
    switch (messageType) {
      case 'FULL_TOTAL':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.reassignment.capacityStatus.fullCapacity"
        });
      case 'FULL_MESSAGING':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.reassignment.capacityStatus.fullCapacityForMessaging"
        });
      case 'FULL_ASYNC':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.reassignment.capacityStatus.fullCapacityForAsync"
        });
      default:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.reassignment.capacityStatus.fullCapacity"
        });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [getMessageContent(), /*#__PURE__*/_jsx(HelpIcon, {
      alignWithText: true,
      marginInlineStart: "100",
      title: I18n.text('routing-ui.reassignment.capacityStatus.tooltip.fullCapacity')
    })]
  });
};
FullCapacityMessage.displayName = 'FullCapacityMessage';
export const OverCapacityMessage = ({
  messageType
}) => {
  const getMessageContent = () => {
    switch (messageType) {
      case 'OVER_TOTAL':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.reassignment.capacityStatus.overCapacity"
        });
      case 'OVER_MESSAGING':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.reassignment.capacityStatus.overCapacityForMessaging"
        });
      case 'OVER_ASYNC':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.reassignment.capacityStatus.overCapacityForAsync"
        });
      default:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.reassignment.capacityStatus.overCapacity"
        });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [getMessageContent(), /*#__PURE__*/_jsx(HelpIcon, {
      alignWithText: true,
      marginInlineStart: "100",
      title: I18n.text('routing-ui.reassignment.capacityStatus.tooltip.overCapacity')
    })]
  });
};
OverCapacityMessage.displayName = 'OverCapacityMessage';